export default "__VITE_PUBLIC_ASSET__12a6b20f__"